var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.547 13.4403L14.547 1.44033C14.067 0.960325 13.4003 0.666992 12.667 0.666992H3.33366C1.86699 0.666992 0.666992 1.86699 0.666992 3.33366V12.667C0.666992 13.4003 0.960325 14.067 1.45366 14.5603L13.4537 26.5603C13.9337 27.0403 14.6003 27.3337 15.3337 27.3337C16.067 27.3337 16.7337 27.0403 17.2137 26.547L26.547 17.2137C27.0403 16.7337 27.3337 16.067 27.3337 15.3337C27.3337 14.6003 27.027 13.9203 26.547 13.4403ZM5.33366 7.33366C4.22699 7.33366 3.33366 6.44033 3.33366 5.33366C3.33366 4.22699 4.22699 3.33366 5.33366 3.33366C6.44033 3.33366 7.33366 4.22699 7.33366 5.33366C7.33366 6.44033 6.44033 7.33366 5.33366 7.33366Z",
    fill: "url(#paint0_linear_3821_13656)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3821_13656",
    x1: 27.3337,
    y1: 14.0003,
    x2: 0.666992,
    y2: 14.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF864C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.d3d4d2fcccd757b24afaf39032372bb5.svg";
export { ForwardRef as ReactComponent };